import GridPoint from '../Gridpoint';

const TableFoot = () => (
    <div className="table-foot mobile-only">
        <GridPoint />
    </div>
);

export default TableFoot;
